<template>
  <div>
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <!-- https://www.npmjs.com/package/vue-notification -->
    <notifications group="general" position="top right" :duration="-1">
      <template slot="body" slot-scope="props">
      <div class="general-notify">
          <a class="title fs-5">
            {{props.item.title}}
          </a>
          <a class="close ms-3" @click="props.close">
            <i class="fas fa-times"></i>
          </a>
          <br/>
          <label v-html="props.item.text">
          </label>
      </div>
  </template>
    </notifications>
  </div>
</template>

<script>
import { getMessaging, onMessage, isSupported } from "firebase/messaging";

export default {
  created(){
    isSupported().then(result => {
      if(result){
        const messaging = getMessaging(this.$firebaseapp);
        onMessage(messaging, (payload) => {
          console.log('Message received. ', payload);
          this.$notify({
            text: payload.data.body,
            title: payload.data.title,
            group: 'general',
          });
        });
      }
    })
  }
};
</script>
<style>
.fade-enter-active, 
.fade-leave-active{
    transition: opacity .5s;
}
.fade-enter, 
.fade-leave-to{
    opacity: 0;
}
</style>
<style lang="scss">
/* for notification */
.general-notify{
  border-radius: 3px;
  margin-top: 1rem;
  padding: 15px;
  margin: 10px;
 
  color: #000000;
  background: #ffffffe3;
  box-shadow:  1px 2px 0 rgba(0, 0, 0, 0.14);
  
  .title{
    font-weight: bolder;
  }

  .close{
    float: right;
    color: #b6b6b6 !important;
    font-size: 12px;

    :hover{
      font-size: 15px;
    }
  }
 
}
</style>

